module.exports = __webpack_public_path__ + "img/cloud-raining-05.41226667.svg";